import { render, staticRenderFns } from "./innerMoveModel.vue?vue&type=template&id=51db170c&scoped=true&"
import script from "./innerMoveModel.vue?vue&type=script&lang=js&"
export * from "./innerMoveModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51db170c",
  null
  
)

export default component.exports